import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

import ProductSelectionsTable from '../../ProductSelectionsTable';
import DetailPanelScrollableTableSection from './DetailPanelScrollableTableSection.jsx';
import {
  DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT,
  DETAIL_PANEL_MIN_TABLE_VIEWPORT_PX,
} from '../utils/detailPanelTableLayout';

// This section embeds the shared ProductSelectionsTable inside the detail drawer
// with drawer-specific layout and feature flags. The goal is to reuse the table's
// operational behavior without bringing along dashboard-only controls.
const DetailPanelProductSelectionsSection = ({
  productSelections,
  userEmail,
  onNavigateToDealer,
  onRowClick,
  onNotify,
  enableVmtQuickActions = false,
}) => {
  return (
    <DetailPanelScrollableTableSection
      data-testid="detail-panel-product-selections-section"
      minHeight={DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT}
      header={
        <Box
          sx={{
            px: 2,
            pt: 2,
            pb: 1,
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            Product Selections
          </Typography>
          <Chip size="small" variant="outlined" label={`${productSelections.length} selections`} />
        </Box>
      }
      bodySx={{ px: 2, pb: 2 }}
    >
      <ProductSelectionsTable
        rows={productSelections}
        userEmail={userEmail}
        onNavigateToDealer={onNavigateToDealer}
        onRowClick={onRowClick}
        onOpenDetail={() => {}}
        isMaximized={false}
        enableInternalScroll
        minTableHeight={DETAIL_PANEL_MIN_TABLE_VIEWPORT_PX}
        tableContainerTestId="detail-panel-product-selections-table-container"
        enableVmtQuickActions={enableVmtQuickActions}
        onNotify={onNotify}
        // Detail mode keeps refresh/compare/export affordances scoped to the
        // surrounding drawer workflow instead of duplicating dashboard controls.
        syncRefreshMode="detail"
        hideRefreshSelections
        hideCompare
        hideExportVisibleCsv
        hideExportVmtTemplate
        hideGlobalSearch
        hideGlobalReset
        hideMaximize
        storageKeySuffix="detail"
      />
    </DetailPanelScrollableTableSection>
  );
};

export default DetailPanelProductSelectionsSection;
